
const $el = $(el);

const $letterHeader = $el.find('.letter-header');
const $filter       = $el.find('.filter');
const $year         = $filter.find('#year');
const $month        = $filter.find('#month');
const $btn          = $filter.find('.btn');
const $noResults    = $el.find('.no-results');

// $letterHeader.on('click', function () {
//     $el.toggleClass('active');
// });

$btn.on('click', function () {
    $el.find(`.wrap-doc`).add($noResults).hide();

    const $results = $el.find(`.wrap-doc[data-year="${$year.val()}"][data-month="${$month.val()}"]`);
    if($results.length > 0) {
        $results.show();
    } else {
        $el.find(`.wrap-doc`).hide();
        $noResults.show();
    }
});

$year.on('change', function () {
    const val = $(this).val();

    $month.find('option').prop('disabled', true);

    $el.find(`.wrap-doc[data-year="${val}"]`).each(function () {
        $month.find(`option[value="${$(this).data('month')}"]`).prop('disabled', false);
    });
});

// select last year and month
const lastYear  = $year.find('option').last().val();
$year.val(lastYear).trigger('change');

const lastMonth = $month.find('option:not(:disabled)').last().val();
$month.val(lastMonth).trigger('change');


